export enum GroupCategoryEnum {
  FREE = 'free',
  PAID = 'paid',
}

export const GroupCategoryLabels = {
  [GroupCategoryEnum.FREE]: 'Grátis',
  [GroupCategoryEnum.PAID]: 'Pago',
}